import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'AZOCSII - 이용약관 | Terms of Service';
  }, []);

  return (
    <div className="min-h-screen bg-bg-canvas">
      <div className="max-w-3xl mx-auto px-4 py-8 md:py-12">
        {/* 헤더 */}
        <div className="mb-8">
          <Link
            to="/"
            className="text-accent hover:text-accent-600 text-sm font-medium"
          >
            &larr; AZOCSII 홈으로
          </Link>
          <h1 className="text-2xl md:text-3xl font-bold text-primary mt-4">
            이용약관
          </h1>
          <p className="text-sm text-gray-500 mt-1">Terms of Service</p>
          <p className="text-sm text-gray-400 mt-2">
            시행일: 2026년 4월 20일 | Effective: April 20, 2026
          </p>
        </div>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          {/* 서비스 정보 */}
          <section>
            <p className="text-sm text-gray-500">
              <strong>서비스명:</strong> AZOCSII (아조씨)<br />
              <strong>운영:</strong> AZOCSII<br />
              <strong>연락처:</strong> azocsii@gmail.com
            </p>
          </section>

          {/* 1. 서비스 목적 및 정의 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              1. 서비스 목적 및 정의
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Purpose and Definition of Service
              </span>
            </h2>
            <p className="text-sm">
              AZOCSII(이하 "서비스")는 콜센터 상담사를 위한 노무 관리 플랫폼으로,
              근무 스케줄 확인, 근무 교환, 출퇴근 관리, 커뮤니티 등의 기능을 제공합니다.
            </p>
            <p className="text-sm text-gray-400 mt-1">
              AZOCSII ("Service") is a labor management platform for call center counselors,
              providing features such as work schedule management, shift swapping, attendance tracking, and community.
            </p>
          </section>

          {/* 2. 이용약관 동의 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              2. 이용약관 동의
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Agreement to Terms
              </span>
            </h2>
            <p className="text-sm">
              서비스에 가입하거나 이용함으로써 본 약관에 동의한 것으로 간주됩니다.
              약관에 동의하지 않는 경우 서비스 이용을 중단해주시기 바랍니다.
            </p>
            <p className="text-sm text-gray-400 mt-1">
              By signing up for or using the Service, you are deemed to have agreed to these Terms.
              If you do not agree, please discontinue use of the Service.
            </p>
          </section>

          {/* 3. 회원가입 및 계정 관리 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              3. 회원가입 및 계정 관리
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Registration and Account Management
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>
                회원가입은 Google 소셜 로그인 또는 이메일로 가능합니다.
                <br />
                <span className="text-gray-400">
                  Registration is available via Google Sign-In or email.
                </span>
              </li>
              <li>
                사용자는 정확한 정보를 제공해야 하며, 계정 보안에 대한 책임이 있습니다.
                <br />
                <span className="text-gray-400">
                  Users must provide accurate information and are responsible for account security.
                </span>
              </li>
              <li>
                초대 코드를 통해 팀에 가입하거나, 회사를 직접 등록할 수 있습니다.
                <br />
                <span className="text-gray-400">
                  Users can join a team via invite code or register a new company.
                </span>
              </li>
            </ul>
          </section>

          {/* 4. 서비스 이용 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              4. 서비스 이용
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Use of Service
              </span>
            </h2>
            <p className="text-sm mb-2">
              서비스는 다음 기능을 포함하며, 추가 기능이 수시로 업데이트될 수 있습니다:
            </p>
            <p className="text-sm text-gray-400 mb-2">
              The Service includes the following features, with additional features updated from time to time:
            </p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>근무 스케줄 확인 및 관리 / Work schedule viewing and management</li>
              <li>근무 교환 신청 및 승인 / Shift swap requests and approvals</li>
              <li>출퇴근 기록 관리 / Attendance tracking</li>
              <li>공정성 포인트 및 로또 시스템 / Fairness points and lottery system</li>
              <li>팀 관리 (관리자) / Team management (admin)</li>
            </ul>
          </section>

          {/* 5. 사용자 의무 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              5. 사용자 의무 (금지행위)
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                User Obligations (Prohibited Activities)
              </span>
            </h2>
            <p className="text-sm mb-2">사용자는 다음 행위를 해서는 안 됩니다:</p>
            <p className="text-sm text-gray-400 mb-2">Users must not engage in the following:</p>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>타인의 계정을 무단으로 사용 / Unauthorized use of another's account</li>
              <li>허위 정보 등록 / Registering false information</li>
              <li>서비스의 정상 운영을 방해하는 행위 / Disrupting normal service operation</li>
              <li>서비스를 이용한 불법 행위 / Illegal activities using the Service</li>
              <li>자동화 도구를 이용한 비정상적 접근 / Abnormal access via automated tools</li>
            </ul>
          </section>

          {/* 6. 서비스 변경 및 중단 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              6. 서비스 변경 및 중단
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Service Changes and Suspension
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>
                운영자는 서비스의 전부 또는 일부를 변경하거나 중단할 수 있습니다.
                <br />
                <span className="text-gray-400">
                  The operator may modify or suspend all or part of the Service.
                </span>
              </li>
              <li>
                서비스 중단 시 사전 공지를 원칙으로 하되, 긴급한 경우 사후 공지할 수 있습니다.
                <br />
                <span className="text-gray-400">
                  Prior notice will be given for service suspension; emergency cases may be notified afterward.
                </span>
              </li>
            </ul>
          </section>

          {/* 7. 지적재산권 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              7. 지적재산권
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Intellectual Property
              </span>
            </h2>
            <p className="text-sm">
              서비스에 포함된 콘텐츠, 디자인, 소프트웨어 등의 지적재산권은 운영자에게 있습니다.
              사용자는 서비스 이용 범위 내에서만 콘텐츠를 사용할 수 있습니다.
            </p>
            <p className="text-sm text-gray-400 mt-1">
              Intellectual property rights for content, design, and software within the Service belong to the operator.
              Users may only use content within the scope of service usage.
            </p>
          </section>

          {/* 8. 면책조항 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              8. 면책조항
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Disclaimer
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>
                서비스는 "있는 그대로" 제공되며, 특정 목적에 대한 적합성을 보증하지 않습니다.
                <br />
                <span className="text-gray-400">
                  The Service is provided "as is" without warranty of fitness for a particular purpose.
                </span>
              </li>
              <li>
                천재지변, 시스템 장애 등 불가항력으로 인한 손해에 대해 책임을 지지 않습니다.
                <br />
                <span className="text-gray-400">
                  We are not liable for damages caused by force majeure or system failures.
                </span>
              </li>
            </ul>
          </section>

          {/* 9. 분쟁 해결 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              9. 분쟁 해결
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Dispute Resolution
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-2 text-sm">
              <li>
                본 약관은 대한민국 법률에 따라 해석되고 적용됩니다.
                <br />
                <span className="text-gray-400">
                  These Terms shall be governed by and construed in accordance with the laws of the Republic of Korea.
                </span>
              </li>
              <li>
                서비스 이용과 관련한 분쟁은 운영자의 주소지 관할 법원에서 해결합니다.
                <br />
                <span className="text-gray-400">
                  Disputes related to service use shall be resolved by the court having jurisdiction over the operator's address.
                </span>
              </li>
            </ul>
          </section>

          {/* 10. 약관 변경 고지 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              10. 약관 변경 고지
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Notice of Terms Changes
              </span>
            </h2>
            <ul className="list-disc pl-5 space-y-1 text-sm">
              <li>
                약관 변경 시 앱 내 공지 또는 이메일로 안내합니다.
                <br />
                <span className="text-gray-400">
                  Changes to Terms will be announced via in-app notice or email.
                </span>
              </li>
              <li>
                변경된 약관의 시행일을 명시합니다.
                <br />
                <span className="text-gray-400">
                  The effective date of changed Terms will be specified.
                </span>
              </li>
            </ul>
          </section>

          {/* 11. 문의처 */}
          <section>
            <h2 className="text-lg font-bold text-primary-800 mb-3">
              11. 문의처
              <span className="block text-xs font-normal text-gray-400 mt-0.5">
                Contact
              </span>
            </h2>
            <p className="text-sm">
              <strong>담당자:</strong> 김환희
              <br />
              <span className="text-gray-400">Contact Person: Joelfelix Kim</span>
            </p>
            <p className="text-sm mt-2">
              이메일 / Email:{' '}
              <a
                href="mailto:azocsii@gmail.com"
                className="text-accent hover:underline"
              >
                azocsii@gmail.com
              </a>
            </p>
          </section>
        </div>

        {/* 상호 링크 */}
        <div className="mt-8 text-center">
          <Link
            to="/privacy"
            className="text-sm text-accent hover:underline"
          >
            개인정보 처리방침 보기
          </Link>
        </div>

        {/* 푸터 */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center text-xs text-gray-400">
          &copy; 2026 AZOCSII. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
